import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { iconsOptions } from 'projects/app-default/src/app/styles/cms.config';
export namespace NCmsProductDeliveryInfoBlock {
    export const ID = 'product-delivery-info-block';

    export interface IBlockData extends Catalog.IBlockData<IBlockContent> {}

    export interface IBlockContent {
        icon: string;
        text: string;
    }
}

@ICmsComponent<CmsProductDeliveryInfoBlockComponent>({
    id: NCmsProductDeliveryInfoBlock.ID,
    block: {
        url: NCmsProductDeliveryInfoBlock.ID
    },
    name: 'Delivery info',
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            title: 'Icon',
            key: 'icon',
            options: iconsOptions,
            previewMode: 'icon',
            required: true
        },
        {
            key: 'text',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Text',
            required: true
        }
    ]
})
@Component({
    selector: 'cms-product-delivery-info-block',
    templateUrl: './cms-product-delivery-info-block.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsProductDeliveryInfoBlockComponent extends UiComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsProductDeliveryInfoBlock.IBlockContent;

    @Input()
    small = false;
}
